export const body = document.body;
export const qs = (s, o = body) => o.querySelector(s);
export const qsa = (s, o = body) => o.querySelectorAll(s);

export const allowStatCookies = window.CookieInformation && CookieInformation.getConsentGivenFor('cookie_cat_statistic');

export function setVhProp() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function initVhUnitOverwrite() {
    setVhProp();
}

export function canUseWebP() {
    const elem = document.createElement('canvas');

    if (elem.getContext && elem.getContext('2d')) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }

    return false;
}

export function addPrefetch(kind, url, as) {
    const linkElem = document.createElement('link');
    linkElem.rel = kind;
    linkElem.href = url;
    if (as) {
        linkElem.as = as;
    }
    linkElem.crossorigin = true;
    document.head.append(linkElem);
}

export function formatNumber(num, seperator = '.') {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${seperator}`);
}

export function debounce(callback, delay) {
    let timer = null;

    return function () {
        const context = this,
            args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function () {
            callback.apply(context, args);
        }, delay);
    };
}

export function loadJS (source, callback) {
    const reference = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');

    script.src = source;
    script.async = true;
    reference.parentNode.insertBefore(script, reference);

    if (callback && typeof(callback) === 'function') {
        script.onload = callback;
    }

    return script;
}

export function getRoundedDimensions({ width, height }) {
    let roundedWidth = width;
    let roundedHeight = height;

    if (roundedWidth % 320 !== 0) {
        roundedWidth = Math.ceil(width / 100) * 100;
        roundedHeight = Math.round((roundedWidth / width) * height);
    }

    return {
        width: roundedWidth,
        height: roundedHeight
    };
}

export function isTouchDevice() {
    return !!('ontouchstart' in window || navigator.maxTouchPoints);
}

export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;